export default {"src":"/_next/static/media/ic-earn-points.4a06c293.svg","height":41,"width":41};